import { UserRole } from "@next-platform/packages-ts-types";
import { useMemo } from "react";
import { useTranslation } from "../features/localization/hooks";
const resolveFeatureDescription = ({ role, translate }) => {
    switch (role) {
        case UserRole.FREE:
            return translate("subscription:page.featuresDescription.free_tier");
        case UserRole.PAID_MINIMAL:
            return translate("subscription:page.featuresDescription.paid_minimal");
        case UserRole.PAID_BASIC:
            return translate("subscription:page.featuresDescription.paid_basic");
        case UserRole.PAID_PREMIUM:
            return translate("subscription:page.featuresDescription.paid_premium");
        case UserRole.SM_BASIC:
            return translate("subscription:page.featuresDescription.sm_basic");
        case UserRole.SM_PREMIUM:
            return translate("subscription:page.featuresDescription.sm_premium");
        default:
            return "";
    }
};
export default function useTranslatedSubscriptionCardFeatures(role) {
    const { t: translate } = useTranslation();
    return useMemo(() => {
        const features = resolveFeatureDescription({ role, translate });
        return features
            .split(";")
            .map((feature) => feature.trim())
            .filter(Boolean);
    }, [role, translate]);
}
